import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'hbo-deactive-modal',
  templateUrl: './deactive-modal.component.html',
  styleUrls: ['./deactive-modal.component.scss']
})
export class DeactiveModalComponent {

  @Input() id?: string | number;
  @Output() confirm = new EventEmitter();


  @Input() head?: string;
  @Input() head5?: string;
  @Input() message?: string;

  @Input() hideConfirm?:boolean;

}
